module.exports = "/_next/static/images/61ee963817ce175bc5648a61c8e39760-clips@mobile480.jpg.webp";